import { memo } from 'react';
import { isEqual } from 'lodash';
import { Box } from '@mui/material';
import {
  CollapsiblePanel,
  EditWorkflowType,
  Skeleton,
  useAssistantRequest,
  useEditorStore,
} from '@diana/core';
import { LayoutBuilder } from '../LayoutBuilder/LayoutBuilder';
import { ITaskBuilderProps } from './TaskBuilder.types';

export const AssetTaskBuilder = memo((props: ITaskBuilderProps) => {
  const { stepId, taskId, flowId } = props;

  const layoutId = useEditorStore((s) => {
    return (
      s.flow?.steps.find((step) => step.stepId === stepId && step.taskId === taskId)?.layoutId ?? ''
    );
  }, isEqual);

  const storeParams = {
    type: EditWorkflowType.Layout,
    flowId: flowId ?? '',
    layoutId: layoutId ?? '',
    componentId: undefined,
  };

  const { hasRequest } = useAssistantRequest(storeParams);

  return (
    <Box
      data-task-id={taskId}
      sx={{
        my: 0,
        '.CollapsiblePanel-header': { p: 2 },
        '.MuiCollapse-wrapperInner > .MuiPaper-root': { pt: 0 },
      }}
    >
      <CollapsiblePanel showCollapseButton={false}>
        {hasRequest ? (
          <div data-testid="builder-task-skeleton-loader">
            <Skeleton count={3} />
          </div>
        ) : (
          <LayoutBuilder layoutId={layoutId} taskId={taskId} stepId={stepId} flowId={flowId} />
        )}
      </CollapsiblePanel>
    </Box>
  );
}, isEqual);
